import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { userLogin } from '../controllers/user';
import { Alert } from 'react-bootstrap';
import { useAuth } from '../components/auth/AuthProvider';
import { Link } from 'react-router-dom';

function Login() {
  const { onLogin } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState();

  useEffect(() => {
    document.title = 'FAMA - Login';
  })

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      let d = await userLogin(email, password);
      onLogin(d);
    }
    catch (e) {
      setError(e.message);
    }
  }

  return (
    <Container>
      <Row className='justify-content-md-center p-4'>
        <Col md={4}>
          <h1>Inicia Sesión</h1>
          {error && <Alert variant='danger'>{error}</Alert>}
          <Form className='mt-4 mb-4' onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" value={email} onChange={e => setEmail(e.target.value)} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
            </Form.Group>
            <Button variant="primary" type="submit">
              Enviar
            </Button>
          </Form>
          <p><Link to={'/forgotpassword'}>Olvidé contraseña</Link></p>
          <p>¿Aún no tienes cuenta? <Link to={'/registro'}>Crea una cuenta nueva</Link>.</p>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
